import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4o7hxpq095: FaireBrandEntity = {
  token: "b_4o7hxpq095",
  type: "brand",
  name: "Sunday Morning",
  avatarUrl:
    "https://cdn.faire.com/fastly/a17ed7553de23b7f13603917c5282a0272b6aaf211841fd4d78270da90e60698.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c31a851d09ad97b82c96c3adab3467ff7130643e8e233a86472cf31b8c385379.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a17ed7553de23b7f13603917c5282a0272b6aaf211841fd4d78270da90e60698.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c31a851d09ad97b82c96c3adab3467ff7130643e8e233a86472cf31b8c385379.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 54,
  isInsider: true,
  description:
    "We were founded on the simple idea that you shouldn't have to choose between high quality, great design, fair pricing and doing good. So we focused on what matters: durable materials, transparent pricing, sustainable production, and tangible giving. By being smart about the way we did things, we could sell beautifully made pieces at honest prices, and through your purchases also help those less fortunate to get a little closer to home.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:39.441Z",
    importedBy: "entity-db-cli",
  },
};
